import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { Heading, Icon, Text } from '@growtherapy/sprout-ui';

export type AppointmentStatus = 'waiting' | 'provider-ready' | 'in-session';

export function YoureAllSetForYourAppointmentCard({ status }: { status: AppointmentStatus }) {
  const t = useTranslate();

  const subtext: Record<AppointmentStatus, string> = {
    waiting: t('telehealth-core:waitingRoom.youCanJoinWhenYourProviderIsReady'),
    'provider-ready': t('telehealth-core:waitingRoom.greatJobCheckingInJoinYourSession'),
    'in-session': t('telehealth-core:waitingRoom.greatJobCheckingIn'),
  };

  return (
    <div className='flex h-full w-full flex-col items-center justify-center gap-4 p-8 text-center'>
      <Icon icon={faCheck} size='2xl' aria-hidden />
      <div className='flex flex-col gap-2 items-center'>
        <Heading as='h2' variant='md'>
          {t('telehealth-core:waitingRoom.youreAllSetForYourAppointment')}
        </Heading>
        <Text variant='md'>{subtext[status]}</Text>
      </div>
    </div>
  );
}
